var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconMousescroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#fff;}.b{fill:#fff;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2908 -957)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(2908 957)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 10,
    height: 15,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 14,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 3,
    rx: 1,
    transform: "translate(2912 961)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMousescroll);
export default __webpack_public_path__ + "static/media/icon-mousescroll.12a0b555d31b1a182a21d286a770a75b.svg";
export { ForwardRef as ReactComponent };